import type { RuleSetId } from '../../../../model';

// COPY_RULE
export const COPY_RULE = 'state.actions.rule.copy.COPY_RULE' as const;

export type CopyRuleAction = {
	type: typeof COPY_RULE;
	payload: {
		ruleSetId: RuleSetId;
	};
};

export const copyRuleAction = (ruleSetId: RuleSetId): CopyRuleAction => ({
	type: COPY_RULE,
	payload: {
		ruleSetId,
	},
});
